/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

export const WarningCopyWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
});

export const WarningIconWrapper = styled.div({
  paddingRight: '8px',
});

export const WarningBranchCopyWrapper = styled.div({
  width: '100%',
});
